import { getIdToken, retrieveTokens, storeTokens } from "./tokens";
import { getLoginPrefixUrl } from "utils/getLoginPrefixUrl";

export async function makeRefreshRequest() {
  const { refreshToken } = retrieveTokens();

  if (!!refreshToken && refreshToken !== 'undefined') {
    const prefixUrl = await getLoginPrefixUrl();

    await fetch(`${prefixUrl}/oAuth/token/refresh`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({ refresh_token: refreshToken })
    }).then(async (response) => {
      const { token, refresh_token } = await response.json();

      storeTokens(token, refresh_token, 300, getIdToken());
    }).catch(() => storeTokens(null, null, null, null));
  } else {
    storeTokens(null, null, null, null);
  }
}
